import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { api } from '@/lib/api-client';
import { operacoesListSchema, operacaoSchema, parcelaSchema } from './operacoes-schemas';

const keys = {
  list: (clienteId: string | number) => ['operacoes-credito', 'list', String(clienteId)] as const,
  detail: (id: string | number) => ['operacoes-credito', 'detail', String(id)] as const,
};

export function useOperacoesCredito(clienteId: string | number | null) {
  return useQuery({
    queryKey: keys.list(clienteId ?? ''),
    queryFn: ({ signal }) =>
      api(`/api/v2/operacoes-credito?cliente_id=${clienteId}`, {
        schema: operacoesListSchema,
        signal,
      }),
    enabled: !!clienteId,
    staleTime: 30_000,
  });
}

export function useOperacaoDetalhe(id: string | number | null) {
  return useQuery({
    queryKey: keys.detail(id ?? ''),
    queryFn: ({ signal }) =>
      api(`/api/v2/operacoes-credito/${id}`, {
        schema: operacaoSchema,
        signal,
      }),
    enabled: !!id,
    staleTime: 30_000,
  });
}

export function useCreateOperacao(clienteId: string | number | null) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (body: Record<string, unknown>) =>
      api('/api/v2/operacoes-credito', {
        method: 'POST',
        body,
        schema: operacaoSchema,
      }),
    onSuccess: () => {
      if (clienteId) void qc.invalidateQueries({ queryKey: keys.list(clienteId) });
    },
  });
}

export function usePatchParcela(clienteId: string | number | null) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ parcelaId, operacaoId, ...body }: { parcelaId: number; operacaoId: number } & Record<string, unknown>) =>
      api(`/api/v2/operacoes-credito/parcelas/${parcelaId}`, {
        method: 'PATCH',
        body,
        schema: parcelaSchema,
      }),
    onSuccess: (_data, vars) => {
      void qc.invalidateQueries({ queryKey: keys.detail(vars.operacaoId) });
      if (clienteId) void qc.invalidateQueries({ queryKey: keys.list(clienteId) });
    },
  });
}
